module.exports = __webpack_public_path__ + "static/media/flags.e5b1de13.svg";